"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(Froala) {
  Froala.PLUGINS.filestackPlugin = function (editor) {
    var show = function show() {
      var _editor$opts, _editor$opts$filestac;

      (_editor$opts = editor.opts) === null || _editor$opts === void 0 ? void 0 : (_editor$opts$filestac = _editor$opts.filestack()) === null || _editor$opts$filestac === void 0 ? void 0 : _editor$opts$filestac.pick(function (response) {
        if (editor.snapshot.filestack) {
          editor.snapshot.restore(editor.snapshot.filestack);
        }

        editor.events.focus();
        editor.selection.restore();
        editor.image.insert(response.url);
      }, showError);
    };

    var showError = function showError() {
      var popup = editor.popups.get('image.insert');
      var layer = popup.find('.fr-image-progress-bar-layer');
      layer.addClass('fr-error');
      layer.find('h3').text('Something went wrong');
    };

    var _init = function _init() {
      Froala.DefineIcon('filestackIcon', {
        NAME: 'filestackIcon',
        SVG_KEY: 'imageManager'
      });
      Froala.RegisterCommand('showFilestack', {
        title: 'Browser',
        icon: 'filestackIcon',
        undo: false,
        focus: true,
        showOnMobile: true,
        refreshAfterCallback: true,
        callback: function callback() {
          this.selection.save();
          this.snapshot.filestack = this.snapshot.get();
          this.popups.hideAll();
          this.filestackPlugin.show();
        }
      });
    };

    return {
      _init: _init,
      show: show
    };
  };
};

exports.default = _default;